// extracted by mini-css-extract-plugin
export default {"sec":"NewProduct_sec__9H+hr","form":"NewProduct_form__srjaN","h2":"NewProduct_h2__YZufS","img":"NewProduct_img__d90+X","successP":"NewProduct_successP__hUXOk"};